$shm_hitalama_map_widget_float_autoview $shm_hitalama_map_widget_float
	tools_custom /
		^ autoview_plain_tools /
			<= Font_size_tool $shm_hitalama_map_fontsize
				font_size? <=> font_size? 14
	View $shm_hitalama_map_widget_view_autoview
		code_widget <= code_widget $shm_hitalama_map_widget
		sub => content
		Map_page <= Map_page
		result => result
